import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IInitializeServerWithLocalUserParams extends ILoginParams {
  displayName: string;
}

export class InitializeServerWithLocalUserRequest extends Request<IInitializeServerWithLocalUserParams, ISessionInfo> {
  constructor(params: IInitializeServerWithLocalUserParams) {
    super('initializeServerWithLocalUser', params);
  }
}
